(() => {
  const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
  const safari = /^((?!chrome|android|crios|fxios).)*safari/i.test(navigator.userAgent);
  const hydrate = frame => {
    const video = frame.querySelector('video');
    if (!video || video.dataset.hydrated || reducedMotion.matches) return;
    if (safari) video.querySelectorAll('source[type="video/webm"]').forEach(source => source.remove());
    video.querySelectorAll('source[data-src]').forEach(source => {
      source.src = source.dataset.src;
      source.removeAttribute('data-src');
    });
    video.dataset.hydrated = 'true';
    video.load();
  };
  const setPlayback = (frame, visible) => {
    const video = frame.querySelector('video');
    if (!video || !frame.hasAttribute('data-autoplay') || reducedMotion.matches) return;
    if (visible) {
      hydrate(frame);
      video.play().then(() => frame.classList.add('is-playing')).catch(() => {});
    } else {
      video.pause();
    }
  };
  const mount = root => {
    root.querySelectorAll('[data-lus-premium-media]:not([data-lus-media-mounted])').forEach(frame => {
      frame.dataset.lusMediaMounted = 'true';
      const mediaState = frame.closest('[data-lus-scroll-media-state]');
      let sufficientlyVisible = false;
      const refreshPlayback = () => {
        const activeState = !mediaState || mediaState.classList.contains('is-active');
        setPlayback(frame, sufficientlyVisible && activeState);
      };
      const observer = new IntersectionObserver(entries => entries.forEach(entry => {
        if (entry.isIntersecting) hydrate(frame);
        sufficientlyVisible = entry.intersectionRatio >= .45;
        refreshPlayback();
      }), { rootMargin: '320px 0px', threshold: [0, .45] });
      observer.observe(frame);
      if (mediaState) {
        const stateObserver = new MutationObserver(refreshPlayback);
        stateObserver.observe(mediaState, { attributes: true, attributeFilter: ['class'] });
      }
      const play = frame.querySelector('[data-lus-media-play]');
      play?.addEventListener('click', () => {
        const video = frame.querySelector('video');
        hydrate(frame);
        video?.play().then(() => frame.classList.add('is-playing')).catch(() => {});
      });
    });
  };
  const start = () => mount(document);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', event => mount(event.target));
})();
